import {
  AvailabilitySearchResponse,
  AvailabilitySearchTimeSlot,
} from "../domain_objects/AvailabilitySearchResponse";

export type TimeSlot = {
  MicrositeName?: string;
  TimeSlot: AvailabilitySearchTimeSlot;
};

export const AvailabilitySearchResponseToTimeSlotList = (
  availabilitySearchResponse: AvailabilitySearchResponse
): TimeSlot[] => {
  if (
    availabilitySearchResponse.MicrositeName &&
    availabilitySearchResponse.TimeSlots
  ) {
    const timeSlotList = availabilitySearchResponse.TimeSlots.map((t) => {
      const timeSlot: TimeSlot = {
        MicrositeName: availabilitySearchResponse.MicrositeName!,
        TimeSlot: t,
      };
      return timeSlot;
    });
    return timeSlotList;
  }
  return [];
};

export const AvailabilitySearchTimeSlotToTimeSlot = (
  availabilitySearchTimeSlot: AvailabilitySearchTimeSlot,
  micrositeName: string
): TimeSlot => {
  const timeSlot: TimeSlot = {
    MicrositeName: micrositeName,
    TimeSlot: availabilitySearchTimeSlot,
  };
  return timeSlot;
};
